import Link from "next/link";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import {
  getVtctCourseBreadcrumbLabel,
  isVtctCoursePath,
} from "@/utils/vtct-course-page";

type CourseBreadcrumbProps = {
  pathname: string;
  pageTitle?: string | null;
};

export default function CourseBreadcrumb({
  pathname,
  pageTitle,
}: CourseBreadcrumbProps) {
  if (!isVtctCoursePath(pathname)) {
    return null;
  }

  const courseLabel = getVtctCourseBreadcrumbLabel(pathname, pageTitle);

  return (
    <nav aria-label="Breadcrumb" className="mb-4 text-sm text-gray-500">
      <ol className="flex flex-wrap items-center gap-1">
        <li>
          <Link href="/" className="hover:text-brand-600">
            Home
          </Link>
        </li>
        <li aria-hidden="true">
          <ChevronRightIcon className="inline h-4 w-4" />
        </li>
        <li>
          <Link href="/courses/vtct/" className="hover:text-brand-600">
            VTCT
          </Link>
        </li>
        <li aria-hidden="true">
          <ChevronRightIcon className="inline h-4 w-4" />
        </li>
        <li className="font-medium text-gray-700" aria-current="page">
          {courseLabel}
        </li>
      </ol>
    </nav>
  );
}
